import { render, staticRenderFns } from "./processStart.vue?vue&type=template&id=623cc206&"
import script from "./processStart.vue?vue&type=script&lang=js&"
export * from "./processStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports